import { DestroyRef, Injectable, inject, signal } from '@angular/core';

import { Observable, fromEvent } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Injectable({
  providedIn: 'root',
})
export class SidenavService {

  public opened = signal(false);
  public mode = signal<'over' | 'push' | 'side'>('side');
  public resize$: Observable<Event> = fromEvent(window, 'resize')
    .pipe(
      debounceTime(300),
    );

  private _smallBreakpoint = 1023;
  private _destroyRef = inject(DestroyRef);

  constructor() {
    this._updateSettings();

    this.resize$
      .pipe(
        tap(() => {
          this._updateSettings();
        }),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe();
  }

  public toggle(): void {
    this.opened.update((opened: boolean) => !opened);
  }

  public open(): void {
    this.opened.set(true);
  }

  public close(): void {
    this.opened.set(false);
  }

  public hide(): void {
    if (window.innerWidth < this._smallBreakpoint) {
      this.opened.set(false);
    }
  }

  private _updateSettings(): void {
    if (window.innerWidth < this._smallBreakpoint) {
      this.mode.set('over');
      this.opened.set(false);
    } else {
      this.mode.set('side');
      this.opened.set(true);
    }
  }

}
